export const dogFilterCategories = [
  { key: 'brand', label: 'Brand' },
  { key: 'category', label: 'Category' },
  { key: 'age', label: 'Life Stage' },
  { key: 'breed', label: 'Breed' },
  { key: 'needs', label: 'Care/Health needs' },
  { key: 'size', label: 'Breed Size' },
  { key: 'productSize', label: 'Product Size' },
]

export default dogFilterCategories
